import _List from './List';
import './style';

export type { ListProps } from './List';
export * from './type';

export const List = _List;
export default List;
